import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  formatDate(d : Date): any {
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let day = d.getDate();
    let _month = month < 10 ? '0' + month.toString() : month.toString();
    let _day = day < 10 ? '0' + day.toString() : day.toString(); 
    return _day + '/' + _month + '/' + year;
  
  }
  setUTCDate(d : Date) : Date {
    return new Date(Date.UTC(d.getFullYear(),d.getMonth(),d.getDate() ))
    
  }
}


